import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  RydeProcessTitle,
  RydeUiUnit,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkJourneyAssign = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const bulkJourneyAssignProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkJourneyAssign,
    entity,
  );

  const bulkJourneyAssignProcess = useRecoilValue(
    activeProcessSF(bulkJourneyAssignProcessKey),
  );
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      addressedFieldsValueOnCompleted(process);
    },
    [addressedFieldsValueOnCompleted],
  );

  useEffect(() => {
    handleProcess({
      entity,
      processTitle: RydeProcessTitle.BulkJourneyAssign,
      toastSummaryOnComplete: true,
      process: bulkJourneyAssignProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
    });
  }, [bulkJourneyAssignProcess, entity, onComplete, stopProcessPolling, t]);
};
